import { getSelectedGym, getSelectedFun } from './api';
import Params from "./getParams";

document.addEventListener("DOMContentLoaded", function () {
  const getFunc = Params.isGym ? getSelectedGym : getSelectedFun
  getFunc()
  .then(function (response) {
    
    const courseArr = response.data.messages
      courseArr.forEach((ele, idx) => {
        createTable(ele,idx)
        appendTable(ele,idx)
      })
    })
    .catch(function (error) {
      const statusCode = error.response.status
      const errorMsg = error.response.data.message;
      if (statusCode === 422) {
        showErrorMsg(errorMsg)
      }
      console.log(errorMsg);
    })

})

function createTable(data,idx){

  const wrapper = document.getElementById("personalWrapper");
  const insertHtml = `
  <p class=''>學生：${data.student} &nbsp ${data.courses.length === 0 ? '(尚未登記任何課程)' : ''}</p>
  <table class="table table-bordered mb-5" id='courseTable${idx+1}'>
    <thead >
      <tr>
        <th scope="col">#</th>
        <th scope="col">課程名稱</th>
        <th scope="col">日期</th>
        <th scope="col">時間</th>
        <th scope="col">老師</th>
      </tr>
    </thead>
    <tbody style='background-color: #fff;' id='tbody${idx+1}'>
    
    </tbody>
  </table>
  `
  wrapper.insertAdjacentHTML('beforeend', insertHtml);
}

function appendTable(data,idx){
  const tableId = `tbody${idx+1}` 
  const tBody = document.getElementById(tableId);
  const courses = data.courses
  
  courses.forEach((ele, idx) => {
    let tr = document.createElement('tr');
    const keyLength = Object.keys(ele).length
    const keyArr = ['title','courseDate', 'courseTime', 'teacher']
    for (let i = 0; i < keyLength; i++) {
      if (i === 0) {
        let indexTd = document.createElement('th');
        indexTd.appendChild(document.createTextNode(idx + 1))
        tr.appendChild(indexTd);
      }
      let td = document.createElement('td');
      let value = ele[keyArr[i]];
      td.appendChild(document.createTextNode(value))
      tr.appendChild(td);
    }
    tBody.appendChild(tr);

  })
}

function showErrorMsg(msg) {
  const title = document.getElementById('msg-title')
  title.innerHTML = msg
}
